import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
export function BonusSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const cardVariants = {
    hidden: {
      opacity: 0,
      scale: 0.95
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5
      }
    }
  };
  return <section className="w-full py-20 md:py-24 px-4 bg-white relative overflow-hidden" data-id="element-1">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-2">
        <div className="absolute -top-24 -right-24 w-96 h-96 bg-light-green rounded-full blur-3xl opacity-50" data-id="element-3"></div>
        <div className="absolute -bottom-24 -left-24 w-96 h-96 bg-light-coral rounded-full blur-3xl opacity-50" data-id="element-4"></div>
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-5">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-6">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-text-heading" data-id="element-7">
            LOS 2 BONOS INCLUIDOS
          </h2>
          <div className="w-24 h-1 bg-secondary-coral mx-auto mt-6 rounded-full" data-id="element-8"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-9">
          {/* Bono 1 */}
          <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 shadow-lg shadow-black/5 border-l-8 border-primary-green relative overflow-hidden" data-id="element-10">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-11">
              <GiftIcon className="w-24 h-24 text-primary-green" data-id="element-12" />
            </div>

            <div className="inline-flex items-center px-4 py-1.5 bg-primary-green/10 text-primary-green font-bold text-sm rounded-full mb-6" data-id="element-13">
              <span className="w-2 h-2 rounded-full bg-primary-green mr-2" data-id="element-14"></span>
              BONO 1
            </div>

            <h3 className="text-2xl font-heading font-bold text-text-heading mb-4" data-id="element-15">
              Banco de Alimentos Puente Argentina
            </h3>

            <div className="space-y-4 text-text-body text-lg relative z-10" data-id="element-16">
              <p className="font-medium text-text-heading" data-id="element-17">
                Edición Súper +100 Combinaciones
              </p>
              <p data-id="element-18">
                En 10 minutos sabés exactamente cuál es el próximo alimento para
                tu hijo sin adivinar ni improvisar. Matriz completa ordenada por
                alimento seguro. Checklist: ¿Es buen puente o es trampa?
                Workbook para armar tu plan personalizado.
              </p>
              <p data-id="element-19">Un alimento mal elegido puede retrasar semanas el proceso.</p>
              <p className="font-bold text-[#3D7A5E]" data-id="element-20">
                Este bono elimina ese riesgo en 10 minutos.
              </p>
            </div>
          </motion.div>

          {/* Bono 2 */}
          <motion.div variants={cardVariants} className="bg-white rounded-2xl p-8 shadow-lg shadow-black/5 border-l-8 border-secondary-coral relative overflow-hidden" data-id="element-21">
            <div className="absolute top-0 right-0 p-6 opacity-10" data-id="element-22">
              <GiftIcon className="w-24 h-24 text-secondary-coral" data-id="element-23" />
            </div>

            <div className="inline-flex items-center px-4 py-1.5 bg-secondary-coral/10 text-secondary-coral font-bold text-sm rounded-full mb-6" data-id="element-24">
              <span className="w-2 h-2 rounded-full bg-secondary-coral mr-2" data-id="element-25"></span>
              BONO 2
            </div>

            <h3 className="text-2xl font-heading font-bold text-text-heading mb-4" data-id="element-26">
              Laboratorio de Texturas
            </h3>

            <div className="space-y-4 text-text-body text-lg relative z-10" data-id="element-27">
              <p className="font-medium text-text-heading" data-id="element-28">
                21 Mini-Experimentos Sensorio-Culinarios
              </p>
              <p data-id="element-29">
                Convertí el rechazo en curiosidad con juegos de 5 minutos. 21
                experimentos listos para hacer hoy. Organizados por fase del
                protocolo. Sin materiales raros. Sin que parezca terapia.
              </p>
              <p className="font-bold text-secondary-coral" data-id="element-30">
                Porque cuando el cerebro investiga sin amenaza, construye
                tolerancia sin darse cuenta.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}